import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';

export interface ReactionResponse {
  id: number;
  adminId: number;
  companyId: number;
  noteId: number;
  base: string;
  unicode: string;
  createdAt: string;
}

export interface ReactionNotePayload {
  noteId: number;
  unicode: string;
}

@Injectable({ providedIn: 'root' })
export class ReactionsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public addNoteReaction(reaction: ReactionNotePayload): Observable<ReactionResponse> {
    return this.httpApi.post('/reactions', {}, { reaction }).pipe(map(({ reaction }) => reaction));
  }

  public removeNoteReaction(reaction: ReactionNotePayload): Observable<ReactionResponse> {
    const { noteId, unicode } = reaction;
    return this.httpApi
      .delete(`/reactions/notes/${noteId}?unicode=${encodeURI(unicode)}`, {}, {})
      .pipe(map(({ reaction }) => reaction));
  }
}
